let dynamicMatchModule = {};

if (__EXPERIMENTAL_SHADOW_DOM__) {
    dynamicMatchModule = function(element, selector) {
        return require('kagekiri').matches(selector, element);
    };
} else {
    dynamicMatchModule = require('matches-selector');
}

module.exports = dynamicMatchModule;
